import { useStepper } from 'LearningManager/hooks/Stepper.context';
import useTenantScope from 'LearningManager/hooks/useTenantScope';

/**
 * Super admins pick it on the Select Courses screen, so their course catalog,
 * learning paths and audience lists all have to be asked for by tenant.
 * Everyone else is already scoped to their own tenant by their token, so no
 * tenant is sent and the APIs answer with what that user can see — which is why
 * this returns `undefined` rather than falling back to some other id.
 */
export const useAssignmentTenantId = (): number | undefined => {
	const { selectedTenantId } = useStepper();
	const { canSelectTenant } = useTenantScope();

	if (!canSelectTenant || !selectedTenantId) return undefined;

	const tenantId = Number(selectedTenantId);
	return Number.isFinite(tenantId) ? tenantId : undefined;
};

export default useAssignmentTenantId;
